import { Injectable } from "@angular/core";
import { HtmlRenderingService } from "@main/reporting.v3/core/rendering/html-rendering.service";
import { FilterInputType, FilterType, IFilterItem, IFilterSettings } from "@features/filter";
import { IEmittedVariable, IFilterRule } from "@main/reporting.v3/core/variables/variable-models";
import { DataType, InputType } from "@main/reporting.v3/core/reporting-models";
import { IFilter } from "@features/filter/interfaces/filter";
import * as moment from "moment/moment";
import { SelectItem } from "primeng/api";

@Injectable()
export class WidgetControlSetAuxiliaryService extends HtmlRenderingService {
    public readonly widgetContainerClass: string = "widget-control-set-container";
    public readonly controlSetFiltersClass: string = "widget-control-set-filters";

    public getFilterTypeByDataType(dataType: DataType): FilterType {
        switch (dataType) {
            case "date":
                return FilterType.Date;
            case "bool":
                return FilterType.Boolean;
            case "numeric":
                return FilterType.Numeric;
            default:
                return FilterType.Text;
        }
    }

    public getFilterValue(filters: IFilter, settings: IFilterSettings): any {
        if (!filters || !settings?.valueFieldName) return null;

        const filter: IFilterItem = filters[settings.valueFieldName];

        if (filter?.value == null) return null;

        switch (settings.inputType) {
            case FilterInputType.Dropdown:
                return this.findLabel(settings.dropdownOptions, filter.value);

            case FilterInputType.Multiselect:
                return filter.value.map((value: any) => this.findLabel(settings.dropdownOptions, value)).join(", ");
        }

        if (settings.filterType === FilterType.Date) {
            return moment(filter.value).format("L");
        }

        return filter.value;
    }

    public isMatch(filterRule: IFilterRule, variable: IEmittedVariable): boolean {
        return !!filterRule?.operand?.startsWith("#") && !variable.name.localeCompare(filterRule.operand.slice(1));
    }

    public findLabel(options: SelectItem[], value: any): string {
        return options?.find(option => option.value === value)?.label;
    }

    public isDropdownType(type: InputType): boolean {
        return type == "dropdown" || type == "multiselect";
    }

    public getDisplayableLabel(value: any): string {
        if (value == null) return "<Not defined>";

        const label: string = String(value);

        if (!label.length) return "<Empty string>";
        if (label.length > 50) return `${label.slice(0, 50)}...`;

        return label;
    }
}